import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { contentKeys } from '../queryKeys'
import { updateContent } from '..'

const useUpdateContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateContent,
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
    },
  })
}

export default useUpdateContentMutation
